export default "__VITE_ASSET__CsNBJaUv__"